import React from 'react'

const Logo = () => (
  <div className="flex-shrink-0 flex items-center">
    <span className="block w-auto font-bold align-middle text-xl">Portkey</span>
  </div>
)

export default Logo
